import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <nav className="navbar navbar-expand-lg navbar-light a1 mx-0  navFont pr-0">
      <section className="container position-relative">
        <div className="logo" onClick={() => navigate("/")}>
          <img src={logo} alt="" />
        </div>
        <div className="toggle-icon-custom">
          <button
            className="navbar-toggler btn-btn-toggle"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </div>
        <div
          className="collapse navbar-collapse  collapse-nav pr-0-lg"
          id="navbarNavAltMarkup"
        >
          <div className="flex-1">
            <div className="navbar-nav">
              <Link className="nav-item nav-link" to="/">
                Home{" "}
              </Link>
              <a className="nav-item nav-link" href="#services">
                Services
              </a>
              <a className="nav-item nav-link" href="#solutions">
                Solutions
              </a>

              {/* <Link className="nav-item nav-link" to="/resource">Resource</Link> */}
              <a className="nav-item nav-link" href="#about">
                About
              </a>
            </div>
          </div>
          <Link to="/contact" className="sigupBtn">
            Contact Us
          </Link>
        </div>
      </section>
    </nav>
  );
};
